<template>
  <div class="boxbgcolor">
    <div class="right content-right list">
      <!-- 页面头部 -->
      <div class="page-header-invoice">
        <div class="header-left">
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            @click="handleBack"
            class="back-btn"
            size="medium"
          >
            返回
          </el-button>
          <h2 class="page-title">关联订单列表</h2>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>订单号:</label>
            <el-input
              v-model="searchForm.orderNo"
              placeholder="请输入订单号"
              clearable
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>车牌号:</label>
            <el-input
              v-model="searchForm.plateNumber"
              placeholder="请输入车牌号"
              clearable
              class="form-control"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="handleSearch"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </el-button>
            </span>
            <span class="search_btn">
              <el-button
                @click="handleReset"
                type="button"
                class="btn btn-default"
              >
                重置
              </el-button>
            </span>
          </div>
        </form>
      </div>

      <!-- 表格区域 -->
      <div class="list-right">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width: 100%"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          highlight-current-row
        >
          <el-table-column
            prop="orderNo"
            label="订单号"
            width="200"
            show-overflow-tooltip
            align="center"
          />
          <el-table-column
            prop="orderType"
            label="订单类型"
            width="100"
            align="center"
          >
            <template #default="scope">
              <el-tag
                :type="getOrderTypeTagType(scope.row.orderType)"
                size="small"
                effect="light"
              >
                {{ scope.row.orderType }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="parkingName"
            label="车场名称"
            width="180"
            show-overflow-tooltip
            align="center"
          />
          <el-table-column
            prop="plateNumber"
            label="车牌号"
            width="100"
            align="center"
          />
          <el-table-column
            prop="orderAmount"
            label="订单金额"
            width="100"
            align="right"
          >
            <template #default="scope">
              <span 
                >¥{{ scope.row.orderAmount.toFixed(2) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="invoiceStatus"
            label="发票状态"
            width="100"
            align="center"
          >
            <template #default="scope">
              <el-tag
                :type="getInvoiceStatusTagType(scope.row.invoiceStatus)"
                size="small"
                effect="light"
              >
                {{ scope.row.invoiceStatus }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right">
            <template #default="scope">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-view"
                @click="handleViewOrderDetail(scope.row)"
                class="detail-btn"
              >
                订单详情
              </el-button>
              <el-button
                type="danger"
                size="small"
                icon="el-icon-close"
                @click="handleVoidInvoice(scope.row)"
                :disabled="scope.row.invoiceStatus === '已冲红'"
                class="void-btn"
              >
                冲红
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 冲红确认弹窗 -->
    <el-dialog
      v-model="voidDialogVisible"
      title="确认冲红"
      width="400px"
      :before-close="handleCloseVoidDialog"
    >
      <div class="void-dialog-content">
        <p>确定要冲红该发票吗？</p>
        <p class="warning-text">冲红后将无法恢复，请谨慎操作！</p>
        <el-form :model="voidForm" label-width="80px">
          <el-form-item label="冲红原因">
            <el-input
              v-model="voidForm.reason"
              type="textarea"
              :rows="3"
              placeholder="请输入冲红原因"
            />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="voidDialogVisible = false">取消</el-button>
          <el-button type="danger" @click="confirmVoid">确认冲红</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/page/commons/page";

export default {
  name: "OrderDetail",
  components: { Page },
  data() {
    return {
      // 搜索表单
      searchForm: {
        orderNo: "",
        plateNumber: "",
        orderType: "",
        orderStatus: "",
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },

      // 冲红弹窗
      voidDialogVisible: false,
      voidForm: {
        reason: "",
      },
    };
  },
  computed: {
    // 表格头部样式
    tableHeaderStyle() {
      return {
        backgroundColor: '#f8f9fa',
        color: '#2c3e50',
        fontWeight: '600',
        fontSize: '14px',
        textAlign: 'center',
        border: 'none'
      }
    },
    // 表格单元格样式
    tableCellStyle() {
      return {
        fontSize: '13px',
        padding: '12px 0',
        textAlign: 'center'
      }
    }
  },
  mounted() {
    this.fetchOrderList();
  },
  methods: {
    receivePaginationData(v1, v2) {
      this.pagination.currentPage = v1;
      this.pagination.pageSize = v2;
      this.fetchOrderList();
    },
    // 获取订单列表
    async fetchOrderList() {
      this.loading = true;
      try {
        // 模拟API调用
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 模拟数据
        this.tableData = [
          {
            id: 1,
            orderNo: "ORD20241201001",
            orderType: "路边停车",
            parkingName: "朝阳区建国路停车场",
            plateNumber: "京A12345",
            orderAmount: 25.0,
            invoiceStatus: "未冲红",
            parkingDuration: "2小时30分钟",
            orderStatus: "已完成",
            createTime: "2024-12-01 10:30:00",
            entryTime: "2024-12-01 08:00:00",
            exitTime: "2024-12-01 10:30:00",
            paymentMethod: "微信支付",
            paymentTime: "2024-12-01 10:35:00",
            invoiceNo: "FP20241201001",
            invoiceTime: "2024-12-01 10:40:00",
          },
          {
            id: 2,
            orderNo: "ORD20241201002",
            orderType: "停车场",
            parkingName: "海淀区中关村停车场",
            plateNumber: "京B67890",
            orderAmount: 150.0,
            invoiceStatus: "未冲红",
            parkingDuration: "5小时15分钟",
            orderStatus: "已完成",
            createTime: "2024-12-01 09:00:00",
            entryTime: "2024-12-01 08:00:00",
            exitTime: "2024-12-01 13:15:00",
            paymentMethod: "支付宝",
            paymentTime: "2024-12-01 13:20:00",
            invoiceNo: "FP20241201002",
            invoiceTime: "2024-12-01 13:25:00",
          },
          {
            id: 3,
            orderNo: "ORD20241201003",
            orderType: "月卡",
            parkingName: "西城区金融街停车场",
            plateNumber: "京C11111",
            orderAmount: 80.0,
            invoiceStatus: "未冲红",
            parkingDuration: "24小时",
            orderStatus: "进行中",
            createTime: "2024-12-01 00:00:00",
            entryTime: "2024-12-01 00:00:00",
            exitTime: "-",
            paymentMethod: "银行卡",
            paymentTime: "2024-12-01 00:00:00",
            invoiceNo: "-",
            invoiceTime: "-",
          },
        ];

        this.pagination.total = this.tableData.length;
      } catch (error) {
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchOrderList();
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        orderNo: "",
        plateNumber: "",
        orderType: "",
        orderStatus: "",
      };
      this.handleSearch();
    },

    // 导出
    handleExport() {
      this.$message.success("导出功能开发中");
    },

    // 刷新
    handleRefresh() {
      this.fetchOrderList();
    },

    // 冲红操作
    handleVoidInvoice(row) {
      if (row.invoiceStatus === "已冲红") {
        this.$message.warning("该发票已经冲红，无法重复操作");
        return;
      }
      this.currentOrder = row;
      this.voidDialogVisible = true;
    },

    // 关闭冲红弹窗
    handleCloseVoidDialog() {
      this.voidDialogVisible = false;
      this.voidForm.reason = "";
    },

    // 确认冲红
    async confirmVoid() {
      if (!this.voidForm.reason.trim()) {
        this.$message.warning("请输入冲红原因");
        return;
      }

      try {
        // 这里调用实际的冲红API
        // await this.$api.voidInvoice({
        //   orderId: this.currentOrder.orderNo,
        //   reason: this.voidForm.reason
        // })

        // 模拟API调用
        await new Promise((resolve) => setTimeout(resolve, 1000));

        this.$message.success("冲红成功");
        // 更新本地数据
        const index = this.tableData.findIndex(
          (item) => item.id === this.currentOrder.id
        );
        if (index !== -1) {
          this.tableData[index].invoiceStatus = "已冲红";
        }
        this.voidDialogVisible = false;
        this.voidForm.reason = "";
      } catch (error) {
        console.error("冲红失败:", error);
        this.$message.error("冲红失败，请重试");
      }
    },

    // 返回上一页
    handleBack() {
      this.$router.go(-1);
    },

    // 查看订单详情
    handleViewOrderDetail(row) {
      // 携带订单号跳转订单页面
      // TODO: 实现订单详情页面跳转逻辑
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchOrderList();
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchOrderList();
    },

    // 获取订单类型标签样式
    getOrderTypeTagType(orderType) {
      const typeMap = {
        路边停车: "warning",
        停车场: "primary",
        月卡: "success",
      };
      return typeMap[orderType] || "info";
    },

    // 获取发票状态标签样式
    getInvoiceStatusTagType(status) {
      const statusMap = {
        已开票: "success",
        已冲红: "danger",
      };
      return statusMap[status] || "info";
    },

    // 获取订单状态标签样式
    getOrderStatusTagType(status) {
      const statusMap = {
        进行中: "primary",
        已完成: "success",
        已取消: "danger",
      };
      return statusMap[status] || "info";
    },
  },
};
</script>

<style scoped>
/* 页面布局样式 - 项目标准版本 */
.boxbgcolor {
  background: #fff;
  display: flex;
  justify-content: flex-start;
  height: 100%;
}

.content-right {
  width: 100%;
}

.list {
  padding: 0 16px 40px;
  height: calc(100vh - 125px);
}

/* 页面头部样式 */
.page-header-invoice {
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.back-btn {
  margin-right: 10px;
}

.page-title {
  margin: 0;
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

/* 搜索区域样式 - 项目标准版本 */
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  padding: 10px;
  margin-bottom: 0;
}

.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 80px;
  vertical-align: middle;
}

.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
  display: flex !important;
  align-items: center !important;
  vertical-align: middle !important;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
  line-height: 1 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.form-control {
  border-radius: 4px;
  transition: border-color 0.2s ease;
  border: none !important;
  box-shadow: none !important;
}

.form-control:focus {
  border-color: #409eff;
}

.others {
  display: -webkit-flex !important;
  display: flex !important;
  justify-content: center;
}

.search_btn {
  display: inline-block;
  margin-right: 5px;
}

/* 按钮样式 - 项目标准版本 */
.btn {
  border-radius: 0px;
  border: 1px solid #409EFF;
  color: #409EFF;
  padding: 6px 20px;
  transition: all 0.2s ease;
}

.btn-primary {
  color: #fff;
  background-color: #409EFF;
  border-color: #409EFF;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.btn-primary:active {
  background-color: #3a8ee6 !important;
  border-color: #3a8ee6 !important;
}

.btn-default {
  background: none;
  color: #409EFF;
}

.btn-default:hover {
  background-color: #409EFF;
  color: #fff;
}

/* 表格区域样式 - 项目标准版本 */
.list-right {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  height: calc(100vh - 250px);
  padding-bottom: 20px;
}

/* 表格美化样式 - 与项目统一 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
}

/* 表头样式优化 - 简化版本 */
.el-table th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border: none !important;
  border-bottom: 1px solid #e4e7ed !important;
  transition: background-color 0.2s ease;
}

.el-table th:hover {
  background: #e9ecef !important;
}

/* 表格行悬停效果 - 简化版本 */
.el-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 斑马纹效果 */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafbfc;
}

/* 表格边框优化 */
.el-table--border th,
.el-table--border td {
  border-right: 1px solid #ebeef5;
}

/* 当前行高亮 */
.el-table__current-row > td {
  background-color: #e3f2fd !important;
}

/* 金额列特殊样式 - 简化版本 */
.amount-text {
  font-family: 'DS-DIGI', monospace;
  font-size: 16px;
  font-weight: 600;
  color: #2e7d32;
  background: #f1f8e9;
  padding: 4px 8px;
  border-radius: 4px;
  border-left: 2px solid #4caf50;
  display: inline-block;
  min-width: 80px;
  text-align: center;
}

/* 标签样式优化 - 简化版本 */
.el-tag {
  border-radius: 4px;
  font-weight: 500;
  padding: 2px 8px;
  transition: all 0.2s ease;
}

.el-tag:hover {
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 操作按钮样式 - 简化版本 */
.detail-btn {
  margin-right: 8px;
  transition: all 0.2s ease;
}

.detail-btn:hover {
  transform: none;
  box-shadow: 0 1px 3px rgba(64, 158, 255, 0.1);
}

.void-btn {
  transition: all 0.2s ease;
}

.void-btn:hover:not(:disabled) {
  transform: none;
  box-shadow: 0 1px 3px rgba(245, 108, 108, 0.1);
}

.void-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 弹窗样式 */
.void-dialog-content {
  text-align: center;
}

.warning-text {
  color: #f56c6c;
  font-weight: bold;
  margin: 10px 0;
}

.dialog-footer {
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .form-group {
    margin-right: 8px;
  }
}

@media (max-width: 992px) {
  .form-group {
    margin-right: 6px;
  }
}

@media (max-width: 768px) {
  .searchbox {
    padding: 8px;
  }
  
  .form-inline {
    height: auto;
    flex-direction: column;
    align-items: stretch;
  }
  
  .form-group {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .list-right {
    margin: 10px;
  }
  
  .page-header-invoice {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .searchbox {
    padding: 6px;
  }
  
  .form-group {
    margin-bottom: 8px;
  }
}
</style>
